import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';
import { ping } from '@phoenix/components/Ping';

export default {
  data() {
    return {
      values: {},
    };
  },

  props: {
    redirectUrl: {
      type: String,
      required: false,
      default: '',
    },
    shouldShowErrorInToast: {
      type: Boolean,
      default: true,
    },
    shouldDisplaySubmitButton: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isHydraEnabled() {
      return getFeatureFlag(FEATURE_FLAG.HYDRA_SSO);
    },

    formAction() {
      return this.isHydraEnabled ? window.route('api.customer.auth.login') : window.route('api.customer.login');
    },
  },

  methods: {
    getRetrievePasswordUrl() {
      let url = '';
      try {
        url = window.route('retrieve_password_page');
      } catch {
        // Route is optional depending on the current localisation.
      }
      return url;
    },

    async addTrackingInformation() {
      let email = '';
      if (this.fields?.email?.value) {
        email = this.fields.email.value;
      } else if (this.fields?.emailOrPhone?.value) {
        email = this.fields.emailOrPhone.value;
      }
      const event = await window.tracking.getLoginFormTracking(email);
      window.tracking.pushEvent(event);
    },

    waitForPageLoad() {
      if (document.readyState === 'complete') {
        return Promise.resolve();
      }

      return new Promise((resolve) => {
        window.addEventListener('load', resolve, { once: true });
      });
    },

    handleSilentLoginSuccess(data) {
      ping.updateLocalStorage(data.pingResult);

      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      }
    },

    async prepareHydraAuth() {
      await this.waitForPageLoad();
      await ping.getData();
      return this.hydraAuth.prepare();
    },

    async beforeSubmit() {
      if (!this.isHydraEnabled) {
        return true;
      }

      this.$refs.phoenixForm.setSubmitButtonLoadingState(true);

      try {
        const data = await this.prepareHydraAuth();

        if (data?.type === 'customer-auth-success') {
          this.handleSilentLoginSuccess(data);

          return false;
        }

        return true;
      } catch {
        this.$refs.phoenixForm.showError(this.$t('MyAccount.ErrorMessageUserLoginFailed'));

        return false;
      } finally {
        this.$refs.phoenixForm.setSubmitButtonLoadingState(false);
      }
    },

    async onSubmitSuccess(response) {
      if (!this.isHydraEnabled) {
        await this.addTrackingInformation();

        return;
      }

      try {
        const data = await this.hydraAuth.continueAuthentication(response.data.data.continueUrl);

        ping.updateLocalStorage(data.pingResult);
      } catch {
        throw new Error(this.$t('MyAccount.ErrorMessageUserLoginFailed'));
      }

      await this.addTrackingInformation();
    },

    async onFormLoaded(event) {
      if (this.isHydraEnabled) {
        try {
          const data = await this.prepareHydraAuth();

          if (data?.type === 'customer-auth-success') {
            this.handleSilentLoginSuccess(data);
          }
        } catch {
          // Silent error, will be retried on submit.
        }
      }

      this.$emit('formLoaded', event);
    },
  },
};
